
<template>
    <div class='content'>
        <div class="container">
            <div class="uploadView">
                <div class="uploadViewBlock">
                    <div class="name">上传资源/试题/班会</div>
                    <div class="type1">
                        <div class="type1T1">请选择类型</div>
                        <div class="radioView">
                            <el-radio v-model="radio" label="1">资源</el-radio>
                            <el-radio v-model="radio" label="2">试题</el-radio>
                            <el-radio v-model="radio" label="3">班会</el-radio>
                        </div>
                    </div>
                    <div class="curView">
                        <div class="curBlock">
                            <div class="curBlockView1" v-if="radio == 1">
                                <div class="curBlockT1">
                                    请选择资源类型：
                                </div>
                                <div class="curBlockT2">
                                    <!-- <el-radio v-model="radio1" label="1">全部</el-radio> -->
                                    <el-radio v-model="radio1" label="2">教案</el-radio>
                                    <el-radio v-model="radio1" label="3">课件</el-radio>
                                    <el-radio v-model="radio1" label="4">学案</el-radio>
                                    <el-radio v-model="radio1" label="5">视频</el-radio>
                                    <el-radio v-model="radio1" label="6">同步</el-radio>
                                    <el-radio v-model="radio1" label="7">素材</el-radio>
                                </div>
                            </div>
                            <div v-if="radio == 3" class="curBlockView1">
                                <div class="curBlockT1">
                                    请选择班会类型：
                                </div>
                                <div class="curBlockT2">
                                    <el-radio v-model="banhuileixing" label="1">班会</el-radio>
                                    <el-radio v-model="banhuileixing" label="2">家长会</el-radio>
                                    <el-radio v-model="banhuileixing" label="3">班主任管理</el-radio>
                                </div>
                            </div>
                            <div v-if="radio == 3 && banhuileixing == 1" class="curBlockView1">
                                <div class="curBlockT1">
                                    请选择班会分类：
                                </div>
                                <div class="curBlockT2">
                                    <el-radio v-model="banhuifenlei" label="1">安全类</el-radio>
                                    <el-radio v-model="banhuifenlei" label="2">教育类</el-radio>
                                    <el-radio v-model="banhuifenlei" label="3">文化类</el-radio>
                                </div>
                            </div>

                            <div v-if="radio == 2 || radio == 1" class="curBlockView1 yangshi">
                                <div class="curBlockT1">
                                    请选择学段：
                                </div>
                                <div class="curBlockT2">
                                    <el-select v-model="valueA" placeholder="请选择" @change="goXD">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div v-if="radio == 1 || radio == 2" class="curBlockView1 yangshi">
                                <div class="curBlockT1">
                                    请选择年级：
                                </div>
                                <div class="curBlockT2">
                                    <el-select v-model="valueB" placeholder="请选择" @change="goNJ">
                                        <el-option v-for="item in options2" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div v-if="radio == 2 || radio == 1" class="curBlockView1 yangshi">
                                <div class="curBlockT1">
                                    请选择学科：
                                </div>
                                <div class="curBlockT2">
                                    <el-select v-model="valueC" placeholder="请选择" @change="goXK">
                                        <el-option v-for="item in options3" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div v-if="radio == 1" class="curBlockView1 yangshi">
                                <div class="curBlockT1">
                                    请选择子项：
                                </div>
                                <div class="curBlockT2">
                                    <el-select v-model="valueZ" placeholder="请选择" @change="goZX">
                                        <el-option v-for="item in optionsZ" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div v-if="radio == 2" class="curBlockView1 yangshi">
                                <div class="curBlockT1">
                                    请选择类型：
                                </div>
                                <div class="curBlockT2">
                                    <el-select v-model="valuelx" placeholder="请选择">
                                        <el-option v-for="item in optionslx" :key="item.value" :label="item.name"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>


                            <div v-if="radio == 1" class="curBlockView1 yangshi">
                                <div class="curBlockT1">
                                    请选择单元：
                                </div>
                                <div class="curBlockT2">
                                    <el-select v-model="valueD" placeholder="请选择" @change="goDY">
                                        <el-option v-for="item in options4" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div v-if="radio == 1" class="curBlockView1 yangshi">
                                <div class="curBlockT1">
                                    请选择章节：
                                </div>
                                <div class="curBlockT2">
                                    <el-select v-model="valueE" placeholder="请选择">
                                        <el-option v-for="item in options5" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="yangshi st">
                        <div class="curBlockT1">
                            请选择标题：
                        </div>
                        <div class="curBlockT2 ts">
                            <el-input v-model="titleN" placeholder="请输入标题"></el-input>
                        </div>
                    </div>
                    <div class="fj">压缩包：</div>
                    <div class="AuploadView" v-loading="loading">
                        <div v-if="fujian" class="wenjian_box" @click.stop>
                            <p>{{ fujianName }}</p>
                            <div class="icon" @click="removeFile"><el-icon name="delete" /></div>
                        </div>
                        <img v-else class="upload_bgc" src="../../assets/images/home/upload_bgc.png" alt="" />
                        <div v-if="!fujian" class="uploadName">
                            txt、word、excel、ppt、PDF、图片、视频、音频文件、压缩包
                            <!-- 仅支持jpg、png、bmp、jpeg、gif、zip、rar、xls、xlsx、<br />
                            <span>mp4、mp3、avi、flv、wmv、doc、word、ppt、pdf、txt、docx</span> -->
                        </div>
                        <input ref="fileRef" type="file"
                            accept=".doc,.docx,.txt,.xls,.xlsx,.ppt,.pdf,audio/*,video/*,image/*,.zip,.rar,.pptx"
                            @change="e => fileUpload('file', e)" />
                    </div>

                    <!-- <div class="fj">上传封面：</div> -->
                    <!--             <div class="AuploadView" v-loading="loading1">
                        <img v-if="headImg" class="upload_bgc" :src="headImg" alt=""
                            style="position: relative;z-index: 1;" />
                        <img v-else class="upload_bgc" src="../../assets/images/home/upload_bgc.png" alt="" />
                        <input style="z-index: 999;" ref="fileRef" type="file"
                            accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                            @change="e => fileUpload('head', e)" />
                    </div> -->

                    <div class="tjView" @click="submit">提交</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading1: false,
            loading: false,
            radio: '1',
            radio1: '1',
            // 学段没 接口你定死就行 1=小学 2=初中 3=高中
            valueA: '',  //学段
            options: [{
                value: '1',
                label: '小学'
            }, {
                value: '2',
                label: '初中'
            }, {
                value: '3',
                label: '高中'
            }],
            valueB: '',  //年级
            options2: [],
            valueC: '',  //学科
            options3: [],
            valueZ: '', // 子项
            optionsZ: [],
            valueD: '',  //单元
            options4: [],
            valueE: '',  //章节
            options5: [],
            value: '',
            zhangjie: [],
            dyList: [],
            titleN: '', //标题
            submitLoading: false,
            headImg: "",
            fujian: "",
            fujianName: "",
            banhuifenlei: "1",
            banhuileixing: "1",
            valuelx: '',
            optionslx: [],
            ids: '',
            allXK: [],  //用于筛选子项

        }
    },
    created() {
        // this.getShiTiType();
    },
    mounted() {
        // console.warn("hhhhhhh")
        if (this.$route.query.data != undefined) {
            console.warn(JSON.parse(this.$route.query.data), "hhhhhhh")
            let data = JSON.parse(this.$route.query.data);
            // console.warn(data.period, "++++学段++++")

            this.goXD(data.period); //学段
            this.getfollowList(data.period, data.grade) //获取学科 
            this.getfollowList2(data.school_subject_id)
            setTimeout(v => {
                this.goDY(data.school_unit_id)
                this.valueE = data.school_chapter_id;
            }, 800)
            this.radio = data.type_data;
            this.radio1 = data.source_data;
            this.valueA = data.period + '';
            this.valueB = data.grade + '';
            this.valueC = data.school_subject_id;


            this.getShiTiType(this.valueC)
            this.valueD = data.school_unit_id;
            this.ids = data.id;
            // this.value = '';
            this.titleN = data.title;
            this.fujian = data.annex_file;
            this.headImg = data.head_image;
            this.banhuileixing = data.class_meet_type;
            this.banhuifenlei = data.class_meet_catgory;
            this.valuelx = data.school_question_type_id;
            this.fujianName = data.file_name;
            // this.radio1 = data.source_data;
        }
    },
    methods: {
        // 获取试题类型
        async getShiTiType(e) {
            const res = await this.$get('school_source/getSchoolQuestionType', {
                school_subject_id: e,
                period: this.valueA

            });
            this.optionslx = (res.data || []).map(item => {
                return { name: item.name, value: item.id }
            });
            // this.testPaperType = this.testPaperArr[0].value || '';
        },
        // type = head || file
        async fileUpload(type, e) {
            if (type == 'head') {
                this.loading1 = true
            } else {
                this.loading = true
            }

            const file = e.target.files[0];
            const res = await this.$customUpload(file);
            console.warn(res)
            if (res.code == 1) {

                if (type == 'head') {
                    this.loading1 = false
                } else {
                    this.loading = false
                }
                this.$message.success(res.msg || '上传succeed');
            } else {
                if (type == 'head') {
                    this.loading1 = false
                } else {
                    this.loading = false
                }
                // console.warn(res)
                this.$message.error(res.msg || '上传fail')
            }
            this.msg
            if (type == 'head') this.headImg = res.data.fullurl;
            else {
                this.fujian = res.data.fullurl;
                this.fujianName = file.name;
            }
            e.target.value = '';
        },
        removeFile() { this.fujian = ''; this.fujianName = ''; },
        async submit() {
            if (this.submitLoading) return;
            if (!this.radio) return this.$message.info('请选择资源类型')
            // if (!this.headImg) return this.$message.info('请上传封面图片')
            const query = {
                type_data: this.radio,
                // head_image: this.headImg,
            };
            if (this.radio1) query['source_data'] = this.radio1;
            if (this.valueA) query['period'] = this.valueA;
            if (this.valueB) query['grade'] = this.valueB;
            if (this.valueC) query['school_subject_id'] = this.valueC;
            if (this.valueZ) query['subject_id_c  '] = this.valueZ;
            if (this.valueD) query['school_unit_id'] = this.valueD;
            if (this.valueE) query['school_chapter_id'] = this.valueE;
            if (this.titleN) query['title'] = this.titleN;
            if (this.fujian) query['annex_file'] = this.fujian;
            if (this.banhuileixing) query['class_meet_type'] = this.banhuileixing;
            if (this.banhuifenlei) query['class_meet_category'] = this.banhuifenlei;
            if (this.valuelx) query['school_question_type_id'] = this.valuelx;
            if (this.ids) query['id'] = this.ids;
            if (this.fujianName) query['file_name'] = this.fujianName;
            try {
                this.submitLoading = true;
                const res = await this.$post('school_source/saveSource', query)
                if (res.code == 1) {
                    this.radio = '1';
                    this.radio1 = '1';
                    this.valueA = '';
                    this.valueB = '';
                    this.valueC = '';
                    this.valueZ = "";
                    this.valueD = '';
                    this.valueE = '';
                    this.value = '';
                    this.titleN = '';
                    this.fujian = '';
                    // this.headImg = '';
                    this.banhuileixing = '1';
                    this.banhuifenlei = '1';
                    this.fujianName = "";
                    this.valuelx = "";
                    this.$message.success('提交succeed');
                } else this.$message.error(res.msg || '提交fail')
            } catch (error) { }
            this.submitLoading = false;


        },
        // 选择学段
        goXD(e) {
            this.valueB = "";
            this.valueC = "";
            this.valueD = "";
            this.valueZ = "";
            this.valueE = "";
            this.valuelx = "";
            this.options2 = [];
            this.options3 = [];
            this.options4 = [];
            this.options5 = [];
            this.optionslx = [];
            this.optionsZ = [];
            if (e == "1") {
                this.options2 = [{
                    value: '1',
                    label: '一年级'
                }, {
                    value: '2',
                    label: '二年级'
                }, {
                    value: '3',
                    label: '三年级'
                }, {
                    value: '4',
                    label: '四年级'
                }, {
                    value: '5',
                    label: '五年级'
                }, {
                    value: '6',
                    label: '六年级'
                }]
            } else if (e == '2') {
                this.options2 = [{
                    value: '7',
                    label: '初一'
                }, {
                    value: '8',
                    label: '初二'
                }, {
                    value: '9',
                    label: '初三'
                }]
            } else {
                this.options2 = [{
                    value: '10',
                    label: '高一'
                }, {
                    value: '11',
                    label: '高二'
                }, {
                    value: '12',
                    label: '高三'
                }]
            }
        },
        // 年级
        goNJ(e) {
            this.valueC = "";
            this.valueZ = "";
            this.valueD = "";
            this.valueE = "";
            this.valuelx = "";
            this.options3 = [];
            this.options4 = [];
            this.options5 = [];
            this.optionslx = [];
            this.optionsZ = [];
            this.getfollowList(this.valueA, e)
        },
        // 获取学科 
        async getfollowList(a, b) {
            this.options3 = [];
            try {
                const res = await this.$get('school_source/getSchoolSubject', {
                    period: a,   //学段:1=小学,2=初中,3=高中
                    grade: b //	年级:1-9年级,10=高一，11=高二，13=高三
                })
                if (res.data.length > 0) {
                    this.allXK = res.data;
                    console.warn(res.data, "data")
                    res.data.forEach(v => {
                        this.options3.push({
                            value: v.id,
                            label: v.name
                        })
                    })
                }
            } catch (error) { }
        },
        // 学科
        goXK() {
            console.warn(this.allXK, "valueC");
            this.valueD = "";
            this.valueE = "";
            this.valuelx = "";
            this.valueZ = "";
            this.optionsZ = [];
            this.options4 = [];
            this.options5 = [];
            this.optionslx = [];
            this.getfollowList2(this.valueC)
            this.getShiTiType(this.valueC)
            this.allXK.forEach(v => {
                if (v.id == this.valueC) {
                    v.child.forEach(a => {
                        this.optionsZ.push({
                            value: a.id,
                            label: a.name
                        })
                    })

                }
            })
            console.warn(this.optionsZ, ' this.optionsZ')
        },
        goZX(e) {
            this.getfollowList2(this.valueC)
            console.warn(e, "eee")
        },
        async getfollowList2(a) {
            // console.warn(a, "jjj")
            this.options4 = [];
            try {
                const res = await this.$get('school_source/getUnitChapter', {
                    school_subject_id: a,   //学科ID
                    subject_id_c: this.valueZ  //子项
                })
                this.zhangjie = res.data.data;
                // console.warn(res.data.data, "单元章节")
                if (res.data.data.length > 0) {
                    this.zhangjie.forEach(v => {
                        this.options4.push({
                            value: v.id,
                            label: v.name
                        })
                    })
                }
            } catch (error) { }
        },
        goDY(e) {
            try {
                // console.warn(e, "+++++++++++++++++sdsds")
                this.valueE = "";
                this.dyList = [];
                this.options5 = [];
                // console.warn(this.zhangjie, "  this.zhangjie")
                this.zhangjie.forEach(v => {
                    if (e == v.id) {
                        this.dyList = v
                    }
                })
                this.dyList.school_chapter.forEach(v => {
                    this.options5.push({
                        value: v.id,
                        label: v.chapter_name
                    })
                })
            } catch (error) { }
            // console.warn(this.dyList)
        },
        dataZ(e) {

        }
    },
}
</script>

<style lang='scss' scoped>
.content {
    min-height: 100%;
    background: #f5f7f9;

    .container {
        display: flex;
        flex-direction: column;

        .uploadView {
            margin: 23px 0 136px 0;
            width: 100%;
            // height: 946px;
            background: #ffffff;

            .uploadViewBlock {
                margin: 37px 291px;

                .name {
                    font-size: 24px;
                    font-family: PingFang SC, PingFang SC-Semibold;
                    font-weight: 600;
                    color: #333333;
                }

                .type1 {
                    margin: 32px 0 12px 0;
                    display: flex;

                    .type1T1 {
                        font-size: 18px;
                        font-family: PingFang SC, PingFang SC-Semibold;
                        font-weight: 600;
                        color: #333333;
                    }

                    .radioView {
                        margin-left: 68px;
                    }
                }

                .curView {
                    margin-top: 12px;
                    width: 618px;
                    background: #f5f7f9;

                    .curBlock {
                        padding: 32px 32px;

                        .curBlockView1 {
                            display: flex;

                            .curBlockT1 {
                                width: 130px;
                                font-size: 16px;
                                font-family: PingFang SC, PingFang SC-Medium;
                                font-weight: bold;
                                color: #333333;
                            }

                            .curBlockT2 {
                                width: 402px;
                                margin-left: 24px;
                                display: flex;
                                flex-wrap: wrap;
                            }
                        }
                    }
                }

                .fj {
                    margin: 39px 0 16px 0;
                    font-size: 18px;
                    font-family: PingFang SC, PingFang SC-Medium;
                    font-weight: bold;
                    color: #333333;
                }

                .AuploadView {
                    display: flex;
                    align-items: center;
                    width: max-content;
                    position: relative;

                    input {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 0;
                        opacity: 0;
                    }

                    .upload_bgc {
                        width: 156px;
                        height: 156px;
                    }

                    .uploadName {
                        margin-left: 24px;
                        font-size: 16px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        color: #333333;
                    }
                }

                .tjView {
                    margin-top: 32px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 258px;
                    height: 42px;
                    background: #d9242a;
                    font-size: 16px;
                    font-family: PingFang SC, PingFang SC-Semibold;
                    font-weight: 600;
                    color: #ffffff;
                }
            }
        }
    }
}

.curBlockT1 {
    width: 130px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: bold;
    color: #333333;
}

.ts ::v-deep .el-input {
    width: 402px !important;
}

.st {
    display: flex;
    justify-content: space-between;
}

.yangshi {
    margin-top: 24px;
    display: flex;
    align-items: center;
}

::v-deep .el-select {
    width: 402px !important;
}

::v-deep .el-radio {
    margin-bottom: 10px !important;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: red;
    background: red;
    width: 16px !important;
    height: 16px !important;
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
    font-size: 18px !important;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: bold;
    color: #333333 !important;
}

::v-deep .el-radio__label {
    padding-left: 10px;
    font-size: 18px !important;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: bold;
    color: #333333 !important;
}

.wenjian_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .icon {
        margin-left: 32px;
        flex-shrink: 0;
        font-size: 20px;
        color: #f22424;
        cursor: pointer;
        position: relative;
        z-index: 3;
    }
}
</style>